import { render } from "./CheckboxInput.vue?vue&type=template&id=212c5173&scoped=true&ts=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts"

import "./CheckboxInput.vue?vue&type=style&index=0&id=212c5173&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212c5173"]])

export default __exports__